import styled, { css } from 'styled-components';

import { radius } from '@/styles/sizes';

type InputStyleProps = {
  css?: StyledCss;
  sizeType: SizeType;
  showBg?: boolean;
};

const StyledInputWrapper = styled.input<InputStyleProps>`
  width: 100%;
  color: ${({ theme }) => theme.colors.gray700};
  font-weight: 600;
  padding: 12px;
  border: none;
  outline: none;
  background-color: transparent;
  transition: all 0.2s;
  overflow: hidden;
  border-radius: ${radius.token.md}px;
  border: 1px solid transparent;

  ${({ showBg = true }) =>
    showBg &&
    css`
      background-color: ${(props) => props.theme.colors.ND04};
    `}

  ${({ sizeType }) => {
    switch (sizeType) {
      case 'xs':
        return css`
          height: 28px;
          font-size: 10px;
        `;
      case 's':
        return css`
          height: 32px;
          font-size: 12px;
        `;
      case 'm':
        return css`
          height: 40px;
          font-size: 14px;
        `;
      case 'l':
        return css`
          height: 48px;
          font-size: 16px;
        `;
      case 'xl':
        return css`
          height: 58px;
          font-size: 18px;
        `;
    }
  }};

  :hover {
    background-color: ${({ theme }) => theme.colors.gray250};
    color: ${({ theme }) => theme.colors.gray700};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.gray250};
    color: ${({ theme }) => theme.colors.gray800};
    border: 1px solid ${({ theme }) => theme.colors.gray600};
  }

  :disabled {
    border-bottom: 1px solid transparent;
  }

  ${({ css }) => css && css};
`;

const TitleInputStyle = {
  StyledInputWrapper,
};

export default TitleInputStyle;
